document.addEventListener('DOMContentLoaded', function() 
{
    var tabs = document.querySelectorAll( '.wi-collection-tab' );
    tabs.forEach( function( tab ) 
    {

        tab.addEventListener( 'click', function() 
        {
            var allTabs = document.querySelectorAll( '.wi-collection-tab' );
            allTabs.forEach(function( tab ) 
            {
                tab.classList.remove( 'active' );
            });
    
            var tabId = tab.getAttribute( 'data-tab-id' );
            tab.classList.add( 'active' );
            showTabContents( tabId );
        });
    });

    function showTabContents( tabId ) 
    {
        var tabContents = document.querySelectorAll( '.wi-collection-tab-content' );
        tabContents.forEach(function(content) 
        {
            content.classList.remove('active');
        });

        var selectedTabContent = document.getElementById( 'tab-' + tabId );
        selectedTabContent.classList.add( 'active' );
    }
});